import {
  Menu,
  MenuPopover,
  MenuButton,
  MenuItems,
  MenuLink,
} from "@reach/menu-button"
import { positionRight } from "@reach/popover"
import { Icon } from "source/shared/components"
import { ANDROID_DOWNLOAD_URL, IOS_DOWNLOAD_URL } from "../constants"
import { Link } from "react-router-dom"
import { useGivingOrganizationContext } from "../hooks/useGivingOrganizationContext"
import { Heading } from "@planningcenter/doxy-web"

export interface WaysToGiveProps {
  currentPersonTextToGiveIsConnected: boolean
}

export default function WaysToGive({
  currentPersonTextToGiveIsConnected,
}: WaysToGiveProps) {
  const { givingOrganization } = useGivingOrganizationContext()
  const shouldShowDropdown =
    givingOrganization.church_center_settings_app_enabled ||
    givingOrganization.text2give_enabled
  const giveNowUrl = "/giving"

  if (!shouldShowDropdown) {
    return (
      <Link to={giveNowUrl} className="btn minor-btn primary-btn" tabIndex={0}>
        Give now
      </Link>
    )
  }

  return (
    <Menu>
      <MenuButton className="minor-btn secondary-btn btn ways-to-give__button">
        Ways to give
        <span className="dropdown-trigger__icon ways-to-give__chevron-container">
          <Icon
            symbol="general#down-chevron"
            aria-hidden
            className="ways-to-give__chevron"
          />
        </span>
      </MenuButton>

      <MenuPopover
        position={positionRight}
        className="ways-to-give__menu-popover"
      >
        <MenuItems role="menu">
          <div className="ways-to-give__menu-item ways-to-give__item-web">
            <div>
              <Heading level={3} text="On the Web" />
            </div>
            <MenuLink
              as={Link}
              to={giveNowUrl}
              className="btn minor-btn ways-to-give__menu-button"
            >
              Give now
            </MenuLink>
          </div>

          {givingOrganization.church_center_settings_app_enabled && (
            <div
              className="ways-to-give__menu-item ways-to-give__item-default"
              role="menuitem"
            >
              <div>
                <Heading level={3} text="On the mobile app" />
              </div>
              <p className="ways-to-give__text-margin">
                With the free Church Center app, you can donate, view your past
                donations, and more from your mobile device. Get the app for{" "}
                <a
                  className="ways-to-give__menu-link"
                  href={ANDROID_DOWNLOAD_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Android
                </a>
                {" or "}
                <a
                  className="ways-to-give__menu-link"
                  href={IOS_DOWNLOAD_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  iOS
                </a>
                .
              </p>
            </div>
          )}

          {givingOrganization.text2give_enabled && (
            <div className="ways-to-give__menu-item ways-to-give__item-default">
              <h3>Text2Give</h3>
              <p className="ways-to-give__text-margin">
                Donate to {givingOrganization.name} by sending a text message.
              </p>
              <MenuLink
                as={Link}
                className="ways-to-give__menu-link"
                to={"/giving/profile/text-to-give"}
              >
                {currentPersonTextToGiveIsConnected
                  ? "Manage your settings"
                  : "Get started"}
              </MenuLink>
            </div>
          )}
        </MenuItems>
      </MenuPopover>
    </Menu>
  )
}
